<template>
  <b-form @submit="onSubmit" class="frm-tabs">
    <b-card no-body class="radius-top-0">
      <template #footer>
        <div class="d-flex justify-content-between align-items-center">
          <b></b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="bagsis">Salvar</b-button>

            <b-button
              @click="$emit('cancel')"
              :to="cancel_to"
              class="btn btn-outline-muted mr-2"
              >Cancelar</b-button
            >
          </div>
        </div>
      </template>

      <b-card>
        <DadosBasicos ref="dados_basicos" />
      </b-card>
    </b-card>
  </b-form>
</template>

<script>
import DadosBasicos from "./Form/DadosBasicos.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: { DadosBasicos },
  props: {
    plenaria_id: {
      required: true,
    },
    cancel_to: {
      type: [String, Object],
      default: () => ({
        name: "pautas_list",
      }),
    },
  },
  data: () => ({
    validations: {
      dados_basicos: true,
    },
  }),
  computed: {
    ...mapState("pautas", ["pauta"]),
  },
  methods: {
    ...mapActions("pautas", ["ActionSave"]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          await this.ActionSave(this.pauta);
          this.$emit("saved", this.pauta.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      return Object.values(this.validations).every(Boolean);
    },
  },
  async created() {},
};
</script>
